import { render, staticRenderFns } from "./addReporterCollection.vue?vue&type=template&id=9812b200&scoped=true"
import script from "./addReporterCollection.vue?vue&type=script&lang=ts"
export * from "./addReporterCollection.vue?vue&type=script&lang=ts"
import style0 from "./addReporterCollection.vue?vue&type=style&index=0&id=9812b200&prod&lang=scss"
import style1 from "./addReporterCollection.vue?vue&type=style&index=1&id=9812b200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9812b200",
  null
  
)

export default component.exports